module.exports = __webpack_public_path__ + "prod/1.42.2/img/flow-qr-code.3219975d.png";